import PropTypes from 'prop-types'
import React from 'react'
import { getData as apiGetData } from 'api/Api'
import { injectIntl, FormattedMessage } from 'react-intl'
import sweetalert from 'sweetalert2'
import { CARD_NAME_MAX_LENGTH } from 'const/limits'
import {
  ButtonGroup
} from 'react-bootstrap'
import Button from 'components/Button'
import CardCopyAction from 'components/CardActions/Copy'
import CardTemplateAction from 'components/CardActions/Template'
import CardMoveAction from 'components/CardActions/Move'
import KanBoIcon from 'components/KanBoIcon'

export class MoreActions extends React.Component {
  static propTypes = {
    id: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    listId: PropTypes.number.isRequired,
    close: PropTypes.func.isRequired,

    intl: PropTypes.object.isRequired,

    boardId: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    isObserved: PropTypes.bool.isRequired,
    allowCardRemove: PropTypes.bool.isRequired,
    myBoardEnabled: PropTypes.bool.isRequired,

    requestMoveCard: PropTypes.func.isRequired,
    requestCopyCard: PropTypes.func.isRequired,
    requestAddCardTemplate: PropTypes.func.isRequired,
    requestArchiveCard: PropTypes.func.isRequired,
    requestDeleteCard: PropTypes.func.isRequired,
    requestAddCardToMyBoard: PropTypes.func.isRequired,
    requestRemoveCardFromMyBoard: PropTypes.func.isRequired,
    requestFollowCard: PropTypes.func.isRequired
  }

  state = {
    action: null,
    isInMyBoard: null
  }

  componentDidMount () {
    this.tryFetchIsInMyBoard()
  }

  componentDidUpdate () {
    this.tryFetchIsInMyBoard()
  }

  tryFetchIsInMyBoard = () => {
    const { id, myBoardEnabled } = this.props
    const { action, isInMyBoard } = this.state

    if (
      action === null &&
      myBoardEnabled &&
      isInMyBoard === null &&
      !this.fetchIsInMyBoardPromise
    ) {
      this.fetchIsInMyBoardPromise = apiGetData('CardInMyBoard', { cardId: id }).then(() => {
        this.setState({
          isInMyBoard: true
        })
      }, () => {
        this.setState({
          isInMyBoard: false
        })
      })
    }
  }

  handleMoveClick = () => {
    this.setState({
      action: 'MOVE'
    })
  }

  handleMove = ({ boardId, statusId }) => {
    const { id, requestMoveCard } = this.props

    requestMoveCard({
      boardId,
      id,
      statusId,
    })

    this.props.close()
  }

  handleCopyClick = () => {
    this.setState({
      action: 'COPY'
    })
  }

  handleCopyValidate = ({ name }) => {
    const { intl } = this.props

    const errors = {}
    if (name && name.length > CARD_NAME_MAX_LENGTH) {
      errors.name = intl.formatMessage({ id: 'CARD_NAME_TOO_LONG' }, { limit: CARD_NAME_MAX_LENGTH })
    }
    return errors
  }

  handleCopySubmit = ({ name }) => {
    const { id, listId, requestCopyCard } = this.props

    if (name) {
      requestCopyCard({
        listId,
        cardId: id,
        name
      })

      this.props.close()
    }
  }

  handleTemplateClick = () => {
    this.setState({
      action: 'TEMPLATE'
    })
  }

  handleTemplateSubmit = ({ name }) => {
    const { boardId, id, requestAddCardTemplate } = this.props

    if (name) {
      requestAddCardTemplate({
        boardId,
        template: id,
        name
      })

      this.props.close()
    }
  }

  handleArchiveClick = () => {
    const { intl, id, name, listId, requestArchiveCard } = this.props

    this.props.close()

    sweetalert({
      text: intl.formatMessage({
        id: 'CARD_ARCHIVE_QUESTION'
      }, {
        name
      }),
      confirmButtonText: intl.formatMessage({ id: 'CARD_ARCHIVE' }),
      cancelButtonText: intl.formatMessage({ id: 'CANCEL' }),
      showCancelButton: true,
      type: 'question'
    }).then(() => {
      requestArchiveCard({
        id,
        listId
      })
    }, () => {})
  }

  handleDeleteClick = () => {
    const { intl, id, name, requestDeleteCard } = this.props

    this.props.close()

    sweetalert({
      text: intl.formatMessage({
        id: 'CARD_DELETE_QUESTION'
      }, {
        name
      }),
      confirmButtonText: intl.formatMessage({ id: 'DELETE' }),
      cancelButtonText: intl.formatMessage({ id: 'CANCEL' }),
      showCancelButton: true,
      type: 'warning',
      confirmButtonClass: 'btn btn-warning'
    }).then(() => {
      requestDeleteCard({
        id
      })
    }, () => {})
  }

  handleMyBoardClick = () => {
    const { id, requestAddCardToMyBoard, requestRemoveCardFromMyBoard } = this.props
    const { isInMyBoard } = this.state

    if (!isInMyBoard) {
      requestAddCardToMyBoard({
        id
      }).then(() => {
        this.setState({
          isInMyBoard: true
        })
      }, (error) => {
        if (error.code === 300) {
          this.setState({
            isInMyBoard: true
          })
        } else {
          throw error
        }
      })
    } else {
      requestRemoveCardFromMyBoard({
        id,
      }).then(() => {
        this.setState({
          isInMyBoard: false
        })
      }, (error) => {
        if (error.code === 401) {
          this.setState({
            isInMyBoard: false
          })
        } else {
          throw error
        }
      })
    }
  }

  handleFollowClick = () => {
    const { id, isObserved, requestFollowCard } = this.props

    requestFollowCard({
      cardId: id,
      isObserved: !isObserved
    })
  }

  render () {
    const {
      boardId,
      name,
      isObserved,
      allowCardRemove,
      myBoardEnabled
    } = this.props
    const {
      action,
      isInMyBoard
    } = this.state

    switch (action) {
      case 'MOVE':
        return (
          <CardMoveAction
            currentBoardId={boardId}
            onMove={this.handleMove}
          />
        )
      case 'COPY':
        return (
          <CardCopyAction
            validate={this.handleCopyValidate}
            onSubmit={this.handleCopySubmit}
            initialValues={{
              name
            }}
          />
        )
      case 'TEMPLATE':
        return (
          <CardTemplateAction
            validate={this.handleCopyValidate}
            onSubmit={this.handleTemplateSubmit}
            initialValues={{
              name
            }}
          />
        )
      default:
        return (
          <React.Fragment>
            <ButtonGroup vertical block>
              <Button
                style={{ textAlign: 'left' }}
                icon={<KanBoIcon fixedWidth name='kanbo-16-move' />}
                onClick={this.handleMoveClick}
              >
                <FormattedMessage id='CARD_MOVE_HEADER' />
              </Button>
              <Button
                style={{ textAlign: 'left' }}
                icon={<KanBoIcon fixedWidth name='kanbo-16-copy-card' />}
                onClick={this.handleCopyClick}
              >
                <FormattedMessage id='CARD_COPY_HEADER' />
              </Button>
              <Button
                style={{ textAlign: 'left' }}
                icon={<KanBoIcon fixedWidth name='kanbo-16-template' />}
                onClick={this.handleTemplateClick}
              >
                <FormattedMessage id='CARD_TEMPLATE_HEADER' />
              </Button>
              <Button
                style={{ textAlign: 'left' }}
                icon={<KanBoIcon fixedWidth name='kanbo-16-archive' />}
                onClick={this.handleArchiveClick}
              >
                <FormattedMessage id='CARD_ARCHIVE' />
              </Button>
              {allowCardRemove &&
                <Button
                  style={{ textAlign: 'left' }}
                  icon={<KanBoIcon fixedWidth name='kanbo-16-delete' />}
                  onClick={this.handleDeleteClick}
                >
                  <FormattedMessage id='DELETE' />
                </Button>
              }
            </ButtonGroup>
            <ButtonGroup vertical block>
              {myBoardEnabled &&
                isInMyBoard === null ? (
                  <Button
                    style={{ textAlign: 'left' }}
                    disabled
                    icon={<KanBoIcon fixedWidth spin name='kanbo-16-loading' />}
                  >
                    <FormattedMessage id='CARD_MYBOARD_ADD' />
                  </Button>
                ) : (
                  <Button
                    style={{ textAlign: 'left' }}
                    icon={<KanBoIcon fixedWidth name='kanbo-16-my-board-2' />}
                    onClick={this.handleMyBoardClick}
                  >
                    <FormattedMessage id={!isInMyBoard ? 'CARD_MYBOARD_ADD' : 'CARD_MYBOARD_REMOVE'} />
                  </Button>
                )
              }
              <Button
                style={{ textAlign: 'left' }}
                icon={<KanBoIcon fixedWidth name={!isObserved ? 'kanbo-16-follow' : 'kanbo-16-unfollow'} />}
                onClick={this.handleFollowClick}
              >
                <FormattedMessage id={!isObserved ? 'FOLLOW' : 'UNFOLLOW'} />
              </Button>
            </ButtonGroup>
          </React.Fragment>
        )
    }
  }
}

export default injectIntl(MoreActions)
